function appController(
  $scope,
  $location,
  $rootScope,
  $timeout,
  userService,
  logger
) {
  const specificPages = [
    '/',
    '/404',
    '/502',
    '/500',
    '/login',
    '/signin',
    '/reset-password',
    '/change-password',
    '/profile',
    '/signup',
    '/admin/firm-management',
    '/invite-friend',
    '/admin/lawyer-listing',
    '/admin/referral-listing',
    '/admin/matching-lawyers-listing',
    '/admin/email-listing',
    '/admin/job-creation',
    '/admin/admin-listings',
    '/admin/inactive-positions',
    '/signup1',
    '/signup2',
    '/forgot',
    '/lock-screen',
    '/admin/applied-jobs',
    '/user-profile',
    '/opportunities',
    '/connections',
    '/home',
    '/admin/lawyer-profile',
    '/admin/job-edit',
    '/admin/job-clone',
    '/for-employers',
    '/about',
    '/faqs',
    '/terms-conditions',
    '/privacy-policy',
    '/invite-friends',
    '/sitemap',
    '/sitemap.xml',
    '/new-lawyer-referral',
    '/admin/matching-lawyers',
    '/site-maintenance',
    '/get-in-touch',
    '/inhouse-jobs',
    '/matches',
    '/unsubscribedWeekly',
    '/pausedWeekly',
    '/admin/firm-notes',
    '/admin/email-history',
    '/admin/email-history-view',
    '/admin/edit-email',
    '/admin/email-body',
  ]

  let loginFailureMsgTimer = undefined

  const displayErrorMessage = errorResponse => {
    logger.notify(
      'error',
      `
      An Error Occurred while performing the request.
      <br/>
      <strong>Error Reason:</strong> ${errorResponse.statusText}
      `
    )
  }

  const disableLoginFailureMsgTimer = () => {
    loginFailureMsgTimer = undefined
  }

  const startLoginFailureMsgDisplayTimer = () => {
    loginFailureMsgTimer = $timeout(disableLoginFailureMsgTimer, 10 * 1000)
  }

  const preventMultipleLoginErrorMessages = () => {
    if (loginFailureMsgTimer) return true
    else {
      startLoginFailureMsgDisplayTimer()
      return false
    }
  }

  $scope.isSpecificPage = function() {
    return _.contains(specificPages, $location.path())
  }

  $scope.refreshUser = () => {
    userService.setUser().then(user => {
      $rootScope.user = user
    })
  }

  $rootScope.errorHandler = errorResponse => {
    if (Object.is(errorResponse.status, 440)) {
      if (preventMultipleLoginErrorMessages()) return

      errorResponse.statusText = 'Not Signed in'
    }

    displayErrorMessage(errorResponse)
  }

  $rootScope.changeStatus = function(status, controller, operation) {
    if (status === 404) {
      controller.alertMsg = 'Page Not Found. Please try again.'
      controller.showOnError = true
    } else if (status === 502) {
      controller.alertMsg = 'Server is not Responded with Bad Request Gateway'
      controller.showOnError = true
    } else if (status === 500) {
      controller.alertMsg =
        'Could not connect to the server. Please try again later.'
      controller.showOnError = true
    } else if (status === 100) {
      controller.alertMsg =
        'Please select a firm by clicking the checkboxes before deleting.'
      controller.showOnError = true
    } else if (status === 409) {
      controller.alertMsg =
        'Another firm with the same name already exists. Please enter a unique firm name'
      controller.showOnError = true
    } else if (status === 200 && operation === 'delete') {
      controller.alertMsg = 'The Firm has been deleted successfully.'
      $scope.isDeleted = true
      controller.showOnSuccess = true
    } else if (status === 200 && operation === 'edit') {
      controller.alertMsg = 'The Firm has been updated successfully.'
      controller.showOnSuccess = true
    } else if (status === 440) {
      $location.url('/signin')
    } else {
      controller.alertMsg =
        'An error has occurred. Please try the action again.'
      controller.showOnError = true
    }
  }
}

angular
  .module('app.controllers')
  .controller('AppCtrl', [
    '$scope',
    '$location',
    '$rootScope',
    '$timeout',
    'userService',
    'logger',
    appController,
  ])



// WEBPACK FOOTER //
// ./scripts/shared/controllers/app.js